import React from 'react';
import { Label } from 'reactstrap';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { observer } from 'mobx-react';
import { IconeCarregar } from '../../../comum/components/Icones';

@observer
export default class TabelaEstoque extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.controller = this.props.controller;
    }

    render() {
        if(this.controller.loading) {
            return <IconeCarregar tamanho="2x" />
        } else if(this.controller.tableMessage !== "") {
            return <Label>{this.controller.tableMessage}</Label>
        } else {
            return (
                <ToolkitProvider
                    keyField="ClienteId"
                    data={this.controller.estoque}
                    columns={this.controller.colunas}
                >
                    {props => 
                    <div className="tabela-overflow">
                        <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    classes="tabela tabela-layout"
                            {...props.baseProps}
                        />
                    </div>
                    }
                </ToolkitProvider>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/estoque/components/TabelaEstoque.js